export default __webpack_public_path__ + "static/media/job_centrum_symbol.80d2209a.svg";